"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typefaces = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography/typefaces"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BaseButton = _styledComponents.default.button.withConfig({
  displayName: "BaseButton",
  componentId: "sc-1qmeau6-0"
})(["font-family:", ";margin:0;overflow:visible;-webkit-appearance:button;&::-moz-focus-inner{border-style:none;padding:0;}"], _typefaces.default.default);

var _default = BaseButton;
exports.default = _default;